<template>
  <div>
    <label v-if="label" class="input-label d-block">{{ label }}</label>
    <button
      type="button"
      class="btn bg-light-white py-3 py-md-1 w-100"
      :class="{ 'disabled-state ': disabled }"
      @click="clickHandler"
    >
      <i class="pr-4" :class="[icon, iconColor]" />
      <span class="text-button-add-document">{{ title }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BoxIconButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: () => 'text-green',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    clickHandler() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped>
.text-button-add-document {
  font-weight: 400;
}

.box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
}

.box i {
  font-size: 21px;
  margin-top: 7px;
}

.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}

.disabled-state {
  cursor: not-allowed;
  pointer-events: all !important;
}

.w-49 {
  width: 49%;
}
@media (max-width: 765px) {
  .text-button-add-document {
    font-size: 14px;
  }
}
</style>
